export function isPhone(val) {
	const phoneReg = /^1\d{10}$/;
	return phoneReg.test(val);
}
/**
 * @param val
 * @returns {boolean}
 */
export function isEmail(val) {
	const emailReg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return emailReg.test(val);
}
export function isUrl(path) {
	return /^http[s]?:\/\/([\w-]+\.)+[\w-]+/g.test(path);
}
// 判断是不是微信公众号链接
export function isWxArticleUrl(path) {
	return /^http[s]?:\/\/mp.weixin.qq.com\/s\/[a-zA-Z]([-_a-zA-Z0-9]+)/g.test(path);
}
export const urlsList = [
	{value: '@qq.com'},
	{value: '@126.com'},
	{value: '@163.com'},
	{value: '@sina.com'},
	{value: '@21cn.com'},
	{value: '@sohu.com'},
	{value: '@yahoo.com.cn'},
	{value: '@tom.com'},
	{value: '@etang.com'},
	{value: '@eyou.com'},
	{value: '@56.com'},
	{value: '@x.cn'},
	{value: '@chinaren.comsogou.com'},
	{value: '@citiz.com'},
]
// 只能输入价格，保留小数点后两位
export function moneyInput(val) {
	return val.replace(/[^\d.]/g,'').replace(/\.{2,}/g, '.').replace(/^(\d+)\.(\d\d).*$/, '$1.$2')
}
